import React, { Suspense, useEffect } from 'react'
import { ThemeProvider } from 'react-jss'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import CheckPin from '../../components/pin/check-pin'
import NavigationHeader from '../shared-navigation/navigation-header'
import NavigationSide from '../shared-navigation/navigation-side'
import NavigationWrapper from '../shared-navigation/navigation-wrapper'
import AsyncNavigationFooter from '../shared-navigation/navigation-footer'
import darkTheme from './main-layout-dark.css'
import useSearchParams from '../hooks/useSearchParams'
import UseNotFoundProvider from '../../components/not-found/hooks/use-not-found-context'
import ContinuityProvider from '../../modules/continuity/hooks/continuity-context'
import mainTheme from '../../theme'
import { PagedSearchResult } from '../../modules/search/components/paged-search-result/paged-search-result'
import { segmentTrackHomepageLand } from '../../segment/segment-track'
import { useIsAuthenticated } from '../../hooks/use-is-authenticated'

const WelcomeBackBanner = React.lazy(() => import('../../components/subscriptions/neon/welcome-back/welcome-back-banner'))

const MainLayout = ({ children }) => {
  const { hasSearchParams } = useSearchParams()
  const location = useLocation()
  const isAuthenticated = useIsAuthenticated()
  const theme = useSelector(state => state.theme)
  const showWelcomeBackBanner = useSelector(state => state.ui.showWelcomeBackBanner)
  const styles = darkTheme

  useEffect(() => {
    if (location.pathname === '/' && isAuthenticated) {
      // Add segment data analytics for landing home page
      segmentTrackHomepageLand()
    }
  }, [isAuthenticated, location.pathname])

  return (
    <ThemeProvider theme={mainTheme}>
      <UseNotFoundProvider>
        <div className={`${theme} ${styles.layout}`}>
          {showWelcomeBackBanner && (
            <Suspense fallback="">
              <WelcomeBackBanner />
            </Suspense>
          )}
          <NavigationHeader />
          <NavigationSide />
          <CheckPin />
          <NavigationWrapper>
            <ContinuityProvider>
              <main className={styles.content}>
                {hasSearchParams ? (
                  <PagedSearchResult />
                ) : (
                  <>{children}</>
                )}
              </main>
            </ContinuityProvider>
          </NavigationWrapper>
          <AsyncNavigationFooter
            className={styles.footer}
            location={location}
          />
        </div>
      </UseNotFoundProvider>
    </ThemeProvider>
  )
}

MainLayout.propTypes = {
  children: PropTypes.element
}

MainLayout.defaultProps = {
  children: null
}

export default MainLayout
